import { navigate } from 'svelte5-router'

/** pathname + query of the current page — the value legacy passes as ?ret= / ?redirect= */
function getCurrentReturnUrl(): string {
	return window.location.pathname + window.location.search
}

/**
 * a repeat `assign` toward the SAME href supersedes the still-pending /login
 * navigation and restarts it: doHandle's 401 branch fires once per masked-401
 * boot call, measured 2026-08-28 as 3 navigation starts with 1 abort per page
 * boot. same-href only, so a later redirect toward a different target always
 * navigates, and the TTL lets a user-cancelled navigation retry without a reset
 */
const ASSIGN_TTL_MS = 2000
let lastAssign = { href: '', at: 0 }

/**
 * auth failure = go log in, not an error page. Mirrors the legacy contract of
 * carrying the original URL (NoAccess401's own button: /login?redirect=<ret>),
 * minus the /401 interstitial with its misleading permissions text.
 * Hard navigation on purpose: /login is the legacy pasta login flow.
 */
export function redirectToLoginWithReturn(): void {
	if (typeof window === 'undefined') return
	// already on the login flow — a second redirect would loop via its own API calls
	if (window.location.pathname.startsWith('/login')) return

	const href = `/login?redirect=${encodeURIComponent(getCurrentReturnUrl())}`
	if (href === lastAssign.href && Date.now() - lastAssign.at < ASSIGN_TTL_MS) return
	lastAssign = { href, at: Date.now() }

	window.location.assign(href)
}

/**
 * fatal load error on a pub page: route to the designed /404 page (App.svelte's
 * own route with $t('UI.404.desc')) — the client twin of the backend's
 * ERROR_404 -> "/404?ret=" redirect in SvelteController.respondWithSvelteApp.
 * svelte5-router's navigate(), not history.pushState — the router only picks up
 * its own navigations and popstate.
 */
export function redirectToNotFoundRoute(): void {
	if (typeof window === 'undefined') return

	navigate(`/404?ret=${encodeURIComponent(getCurrentReturnUrl())}`)
}
